import ICON_HIGHLIGHT_TC from '../images/icon-ahaa-highlight-tc.png';
import ICON_HIGHLIGHT_EN from '../images/icon-ahaa-highlight-en.png';
import ICON_HIGHLIGHT_CN from '../images/icon-ahaa-highlight-cn.png';
import ICON_FOOD_HIGHLIGHT_TC from '../images/icon-food-highlight-tc.png';
import ICON_FOOD_HIGHLIGHT_EN from '../images/icon-food-highlight-en.png';
import ICON_FOOD_HIGHLIGHT_CN from '../images/icon-food-highlight-cn.png';
import { LANGUAGE_VALUES } from '../../design-provider';
export var getLanguageImage = function getLanguageImage(language, mode) {
  var imageMap = new Map();
  if (mode === 'living') {
    imageMap.set(LANGUAGE_VALUES.EN, ICON_HIGHLIGHT_EN);
    imageMap.set(LANGUAGE_VALUES.TC, ICON_HIGHLIGHT_TC);
    imageMap.set(LANGUAGE_VALUES.CN, ICON_HIGHLIGHT_CN);
  } else {
    imageMap.set(LANGUAGE_VALUES.EN, ICON_FOOD_HIGHLIGHT_EN);
    imageMap.set(LANGUAGE_VALUES.TC, ICON_FOOD_HIGHLIGHT_TC);
    imageMap.set(LANGUAGE_VALUES.CN, ICON_FOOD_HIGHLIGHT_CN);
  }
  if (language) {
    return imageMap.get(language);
  }
  return ICON_HIGHLIGHT_TC;
};